import { GetTagDataFromURL } from "../../service/service";

/*
 * Data + pure helpers for the redesigned tag page (topic shelf). Source:
 * the legacy POST user/tag-click — a Laravel paginator (20 rows/page) plus
 * the tag's display name: { status, data: [paginator, "Simcha"] }. Rows
 * carry no media/duration fields, so the shelf omits those labels (honest
 * metadata, same rule as search).
 */

export const TAG_PAGE_SIZE = 20;
const NEW_WINDOW_MS = 30 * 24 * 3600 * 1000;

export function normalizeTagRow(r) {
  if (!r?.id || !r?.title) return null;
  // The endpoint also returns unlisted rows (visibility 'private', draft
  // PDFs…); their permalinks 404 for visitors, so keep the shelf public.
  if (r.visibility && r.visibility !== "public") return null;
  if (r.is_publish === 0 || r.is_draft === 1) return null;
  const civil = r.is_publish_date || (r.created_at ? String(r.created_at).slice(0, 10) : null);
  const posted = civil ? new Date(`${String(civil).slice(0, 10)}T00:00:00`) : null;
  return {
    id: r.id,
    title: r.title,
    slug: r.custom_permalink && r.custom_permalink !== "None" ? r.custom_permalink : r.slug,
    dateLabel: posted
      ? posted.toLocaleDateString("en-US", { month: "long", year: "numeric" })
      : null,
    isNew: posted ? Date.now() - posted.getTime() < NEW_WINDOW_MS && posted.getTime() <= Date.now() : false,
  };
}

/**
 * One shelf page. `page` is zero-based (the service adds 1).
 * Returns { name, items, total, lastPage, page } or null — the endpoint
 * 500s on an unknown tag, so null means unknown-or-unreachable (designed
 * 404, matching the legacy page); an empty items array means the tag
 * exists with nothing public under it.
 */
export async function fetchTagShelf(slug, page = 0) {
  try {
    const res = await GetTagDataFromURL({ tag: slug }, page);
    if (!res?.status || !Array.isArray(res.data)) return null;
    const [paginator, name] = res.data;
    const rows = Array.isArray(paginator?.data) ? paginator.data : [];
    return {
      name: name || null,
      items: rows.map(normalizeTagRow).filter(Boolean),
      total: Number(paginator?.total) || rows.length,
      lastPage: Number(paginator?.last_page) || 1,
      page,
    };
  } catch (_) {
    return null;
  }
}
